import { UIHeading2 } from '@cian/ui-kit/typography';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { formatPrice, formatRecommendationPrice, TPriceVariant } from './utils';
import { IPriceForMobileSite } from '../../../../../common/repositories/dailyrent/entities/price_for_mobile_site/PriceForMobileSite';
import { Discount } from '../Discount';

interface IPriceProps {
  className?: string;
  price: IPriceForMobileSite;
  hasDates: boolean;
  variant?: TPriceVariant;
  originalPrice?: string | null;
  discountPercent?: string | null;
}

export const Price = ({
  className,
  price,
  hasDates,
  variant = 'default',
  originalPrice,
  discountPercent,
}: IPriceProps) => {
  const formattedPrice = variant === 'recommendation' ? formatRecommendationPrice(price) : formatPrice(price, hasDates);
  const showDiscount = originalPrice && discountPercent;

  return (
    <div className={cn(styles['price-container'], className)}>
      <UIHeading2 data-testid="price">{formattedPrice}</UIHeading2>
      {showDiscount && (
        <div className={styles['discount']} data-testid="discount">
          <Discount originalPrice={originalPrice} discountPercent={discountPercent} />
        </div>
      )}
    </div>
  );
};
